import React from 'react';
import { checkOnlineStatus } from 'common/utils';
import offlineImage from 'static/img/network-error.svg';

class ErrorBoundary extends React.Component {
  state = { error: null };

  handleNetworkRetry = async () => {
    const isOnline = await checkOnlineStatus();

    if (isOnline) {
      location.reload();
    }
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('logErrorToService: ', errorInfo);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="network-error-page">
          <img src={offlineImage} alt="offline-logo" />
          <h2 className="f-medium">Oops!</h2>
          <p className="font-lg">
            Something went wrong. We are working to fix this.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
